import type { RouteRecordRaw } from 'vue-router';
import { HasNavigationLayout } from '@/pages/_layout';

export const adminRoutes: RouteRecordRaw[] = [
    {
        path: '/admin',
        name: 'admin-top',
        component: () => import('@/pages/admin/top/AdminTopPage.vue'),
        meta: {
            title: '管理画面TOP',
            requiresAuth: true,
            layout: HasNavigationLayout,
        },
    },
    {
        path: '/admin/inspection',
        name: 'luggage-inspection',
        component: () => import('@/pages/luggage-inspection/LuggageInspectionPage.vue'),
        meta: {
            title: '荷物検品',
            requiresAuth: true,
            layout: HasNavigationLayout,
        },
    },
    {
        path: '/admin/master-management',
        name: 'admin-master-management',
        component: () => import('@/pages/master-management/MasterManagementPage.vue'),
        meta: {
            title: 'マスタ管理',
            requiresAuth: true,
            layout: HasNavigationLayout,
        },
    },
    {
        path: '/admin/staffs',
        name: 'admin-staffs',
        component: () => import('@/pages/admin/staffs/StaffsPage.vue'),
        meta: {
            title: 'スタッフ一覧',
            requiresAuth: true,
            allowedRoles: ['at-admin'],
            layout: HasNavigationLayout,
        },
    },
    {
        path: '/admin/staffs/new',
        name: 'admin-staff-register',
        component: () => import('@/pages/admin/staff-register/StaffRegisterPage.vue'),
        meta: {
            title: 'スタッフ新規登録',
            requiresAuth: true,
            allowedRoles: ['at-admin'],
            layout: HasNavigationLayout,
        },
    },
    {
        path: '/admin/authentication-codes',
        name: 'admin-authentication-codes',
        component: () => import('@/pages/admin/authentication-codes/AuthenticationCodesPage.vue'),
        meta: {
            title: '認証コード一覧',
            requiresAuth: true,
            layout: HasNavigationLayout,
        },
    },
];
